import learningApi from '../../api/learning/learning.js'

(function ($) {
    $.fn.audioSlideshow = function (options) {

        var settings = {
            jPlayerPath: "/lib/swf",
            suppliedFileType: "mp3",
            playSelector: ".audio-play",
            pauseSelector: ".audio-pause",
            prevSelector: ".tab_audios_a_left",
            nextSelector: ".tab_audios_a_right",
            playBigSelector: ".tab_audios_a_play",
            currentTimeSelector: ".play-time",
            durationSelector: ".total-time",
            playheadSelector: ".playhead",
            timelineSelector: ".timeline"
        };

        if (options) {
            jQuery.extend(settings, options);
        }

        // Begin to iterate over the jQuery collection that the method was called on
        return this.each(function () {

                // Cache `this`
                var $that = $(this),
                    $slides = $that.find('.audio-slides').children(),

                    $currentTime = $that.find(settings.currentTimeSelector),
                    $duration = $that.find(settings.durationSelector),
                    $playhead = $that.find(settings.playheadSelector),
                    $timeline = $that.find(settings.timelineSelector),
                    $playButton = $that.find(settings.playSelector),
                    $pauseButton = $that.find(settings.pauseSelector),
                    $pevButton = $that.find(settings.prevSelector),
                    $nextButton = $that.find(settings.nextSelector),
                    $playBigButton = $that.find(settings.playBigSelector),
                    slidesCount = $slides.length,
                    slideTimes = new Array(),
                    audioDurationinSeconds = parseInt($that.attr('data-audio-duration')),
                    isPlaying = false,
                    isStartedPlaying = false,
                    currentSlide = -1,
                    slideHeight = 0;
                $pauseButton.hide();

                // Setup slides
                $slides.each(function (index, el) {
                    el.onload = function () {
                        if (slideHeight < 100) {
                            slideHeight = this.offsetHeight;
                            if (slideHeight >= $(window).height()) {
                                $that.css('height', $(window).height() - 100)
                                $('.lab-operation').css('height', $(window).height() - 100)
                            }
                            else {
                                $that.css('height', slideHeight + 20)
                                $('.lab-operation').css('height', slideHeight +20)
                            }
                        }
                    };
                    var $el = $(el);
                    $el.hide();

                    var second = parseInt($el.attr('data-slide-time')),
                        thumbnail = $el.attr('data-thumbnail');

                    if (index > 0) {
                        slideTimes.push(second);

                        var img = '<span><img src="' + thumbnail + '"></span>',
                            $marker = $('<a href="javascript:;" class="marker" data-time="' + second + '">' + img + '</a>'),
                            l = ((second / audioDurationinSeconds) * $that.width() - 5) / $that.width() * 100 + '%';//;

                        $marker.css('left', l).click(function (e) {
						                $jPlayerObj.jPlayer("play", parseInt($(this).attr('data-time')) + .5);
                        });

                        $timeline.append($marker);
                    }
                });

                var $jPlayerObj = $('<div></div>');
                $that.append($jPlayerObj);

                $jPlayerObj.jPlayer({
                    ready: function () {
                        $.jPlayer.timeFormat.padMin = false;
                        $(this).jPlayer("setMedia", {
                            mp3: $that.attr('data-audio')
                        });
                    },
                    swfPath: settings.jPlayerPath,
                    supplied: settings.suppliedFileType,
                    preload: 'auto',
                    cssSelectorAncestor: ""
                });

                $jPlayerObj.bind($.jPlayer.event.timeupdate, function (event) { // Add a listener to report the time play began
                    var curTime = event.jPlayer.status.currentTime;
                    audioDurationinSeconds = event.jPlayer.status.duration;
                    var p = (curTime / audioDurationinSeconds) * 100 + "%";

                    $currentTime.text($.jPlayer.convertTime(curTime));
                    $duration.text($.jPlayer.convertTime(audioDurationinSeconds));

                    $playhead.width(p);

                    if (slidesCount) {
                        var nxtSlide = 0;
                        for (var i = 0; i < slidesCount; i++) {
                            if (slideTimes[i] < curTime) {
                                nxtSlide = i + 1;
                            }
                        }

                        setAudioSlide(nxtSlide);
                    }
                });

                $jPlayerObj.bind($.jPlayer.event.play, function (event) { // Add a listener to report the time play began
                    isPlaying = true;
                    isStartedPlaying = true;
                    $playButton.hide();
                    $pauseButton.show();
                });

                $jPlayerObj.bind($.jPlayer.event.pause, function (event) { // Add a listener to report the time pause began
                    var curTime = event.jPlayer.status.currentTime;
                    var routeParams = window.location.search;
                    learningApi.set_lesson_progress(routeParams, curTime).then(function (res) {
                        console.log("set_lesson_progress1", res.data)
                    });
                    isPlaying = false;
                    $pauseButton.hide();
                    $playButton.show();
                });

                $slides.dblclick(function () {
                    if (isPlaying) {
                        $jPlayerObj.jPlayer("pause");
                        $playBigButton.show();
                        $pevButton.hide();
                        $nextButton.hide();
                    }
                });
                $pevButton.click(function (event) {
                    $jPlayerObj.jPlayer("play", parseInt($slides.eq(currentSlide - 1).attr('data-slide-time')) + .5);
                });
                $nextButton.click(function (event) {
                    $jPlayerObj.jPlayer("play", parseInt($slides.eq(currentSlide + 1).attr('data-slide-time')) + .5);
                });

                $playButton.click(function (event) {
                    if (options != undefined) {
                        if (options.code == 'success' && !isStartedPlaying) {
                            $jPlayerObj.jPlayer("play", parseInt(options.progress));
                        } else {
                            $jPlayerObj.jPlayer("play");
                        }

                    } else {
                        $jPlayerObj.jPlayer("play");
                    }
                    $playBigButton.hide();
                    $pevButton.show();
                    $nextButton.show();
                });

                $pauseButton.click(function (event) {
                    $jPlayerObj.jPlayer("pause");
                    $playBigButton.show();
                    $pevButton.hide();
                    $nextButton.hide();
                });
                $timeline.click(function (event) {
                    var l = event.pageX - $(this).offset().left;
                    var t = (l / $that.width()) * audioDurationinSeconds;
                    if (options != undefined) {
                        if (options.code == 'success') {
                            t = (l / $that.width()) * options.duration;
                        }
                    }
                    $jPlayerObj.jPlayer("play", t);
                    $playBigButton.hide();
                    isStartedPlaying = true;
                });

                setAudioSlide(0);

                function setAudioSlide(n) {
                    if (n != currentSlide) {
                        if ($slides.get(currentSlide)) {
                            $($slides.get(currentSlide)).fadeOut();
                        }

                        $($slides.get(n)).fadeIn();
                        if (options != undefined && options.code == 'success' && $playhead[0].style.width) {
                            var curTime = parseInt($playhead[0].style.width)/100 * options.duration;
                            var routeParams = window.location.search;
                            learningApi.set_lesson_progress(routeParams, curTime).then(function (res) {
                                console.log("set_lesson_progress2", res.data)
                            });
                        }

                        currentSlide = n;

                    }
                }

                if (options != undefined) {
                    if (options.code == 'success') {
                        var p = (options.progress / options.duration) * 100 + "%";
                        $playhead.width(p);
                    }

                }


            });
    };
}(jQuery));